//@ts-nocheck
import React, { ReactElement } from 'react';
import styled from 'styled-components';
// import { mdiArrowRight } from '@mdi/js';
// import ReactIcon from '@mdi/react';

import { TeachersCardState } from 'features/teachers';
import { Flex, Typography } from 'components';

import { FlexProps } from 'components/flex/types';
import { Link } from 'react-router-dom';
import { createUrl } from 'app/utils';

interface TeachersCardProps extends FlexProps {
  teacher: TeachersCardState;
}

// const IconWrapper = styled.div`
//   display: inline-block;
//   position: relative;
//   width: 50px;
//   height: 50px;
//   background: ${({ theme }) => theme.colors.dark_350};
//   border-radius: 50%;
//   position: absolute;
//   top: -25px;
//   right: 25px;
// `;

// const Icon = styled(ReactIcon)`
//   display: block;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   transition: 0.2s;
//   width: 25px;
//   color: ${({ theme }) => theme.colors.primary_400};
// `;

const Wrapper = styled(Flex)`
  width: 280px;
  height: 470px;
  border-radius: 4px;
  position: relative;
  background: url(${(props: any) => props['data-imageurl']});
  background-size: cover;
  background-position: center;
`;

const TeacherButton = styled(Flex)`
  background: ${({ theme }) => theme.colors.dark_150};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  position: relative;
  min-height: 120px;
`;

const TeacherLink = styled(Link)`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: flex-end;

  &:hover {
    ${TeacherButton} {
      background: ${({ theme }) => theme.colors.primary_400};
    }
  }
`;

const TeachersCard = ({ teacher, ...props }: TeachersCardProps): ReactElement => {
  return (
    <Wrapper data-imageurl={teacher.cardImageUrl} flexGrow={0} flexShrink={0} {...props}>
      <TeacherLink to={createUrl('teacherDetails', [teacher.slug])}>
        <TeacherButton px={{ m: 25 }} py={{ m: 25 }}>
          {/* <IconWrapper>
            <Icon path={mdiArrowRight} />
          </IconWrapper> */}

          <Typography type="type6" color="white" fontWeight="bold">
            {teacher.name}
          </Typography>
        </TeacherButton>
      </TeacherLink>
    </Wrapper>
  );
};
export default TeachersCard;
